export const CHECKLIST_KEYS = {
  all: ['checklists'] as const,
  byOrg: (orgId: string) => ['checklists', orgId] as const,

  /** All checklists (with items) for a single task. */
  byTask: (orgId: string, taskId: string) => ['checklists', orgId, 'byTask', taskId] as const,
};
